/**
 * Copyright (c) 2026-present, NDLA.
 *
 * This source code is licensed under the GPLv3 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

// N.B! AUTOGENERATED FILE. DO NOT EDIT
// Source: Keyteq
// License: CC-BY 4.0
import type { JSX } from "react";
import { Icon, type Props } from "../Icon";
export const Additional = (props: Props): JSX.Element => (
  <Icon viewBox="0 0 23 23" {...props}>
    <g fill="none" transform="translate(1 1)">
      <circle cx="10.5" cy="10.5" r="10.5" stroke="currentColor" />
      <path fill="currentColor" d="M9.3 8.9H7V7h6.9v1.9h-2.3v6.8H9.3z" />
    </g>
  </Icon>
);
